import styled from "styled-components";
const AboutPageSection = styled.section`
  display: flex;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
`;
export default AboutPageSection;
